import React from "react";
import { useIntl } from "react-intl";
import { TableCell, TableRow } from "@material-ui/core";

const RelatedProtocolsTableEmptyRow = ({}) => {
  const intl = useIntl();

  return (
    <TableRow>
      <TableCell colSpan={4}>
        <span
          style={{
            color: "grey",
          }}
        >
          {intl.formatMessage({ id: "app.sg.details.relatedProtocols.empty" })}
        </span>
      </TableCell>
    </TableRow>
  );
};

export default RelatedProtocolsTableEmptyRow;
